import ProvaService from '../services/prova.service'

export const prova = {
    namespaced: true,
    state: {
        lstProvas: [],
        lstProvasPorProduto: [],
        isLoading: false,
    },
    
    actions: {
        async salvar(_, prova) {
            const resp = await ProvaService.salvar(prova);
            return resp.status;
        }, 

        async getProvaList({ commit }) {
            commit('SET_IS_LOADING', true);
            const resp = await ProvaService.getProvaList();
            commit('SET_PROVA_LIST', resp.data)
            commit('SET_IS_LOADING', false);
            return resp.status;
        }, 

        async getProvaListProduto({ commit }, idResidencia) {
            commit('SET_IS_LOADING', true);
            var resp
            if(idResidencia == null){
                resp = await ProvaService.getProvaList();
            }else{
                resp = await ProvaService.getProvaListPorProduto(idResidencia);

            }
            commit('SET_PROVA_LIST_PRODUTO', resp.data)
            commit('SET_IS_LOADING', false);
            return resp.status;
        }, 

        async excluirProva(_, idProva){
            const resp = await ProvaService.excluirProva(idProva);
            return resp.status;
        },

        async updateProva(_, idProva){
            const resp = await ProvaService.updateProva(idProva);
            return resp.status;
        }
    },

    mutations: {
        SET_PROVA_LIST(state, lstProvas) {
            state.lstProvas = [...lstProvas];
        },
        SET_PROVA_LIST_PRODUTO(state, lstProvas){
            state.lstProvasPorProduto = [...lstProvas];
        },
        SET_IS_LOADING(state, isLoading) {
            state.isLoading = isLoading;
        }
    }
}